import React from 'react';
import { Separator } from './TrialProposalSeparator';
import { StyledSmall, StyledSmallDiv } from './TrialProposalSmall';

export const TrialProposal = () => (
  <StyledSmallDiv>
    <StyledSmall text="Free trial" />
    <Separator />
    <StyledSmall text="No credit card needed" />
  </StyledSmallDiv>
);
